import {
  INTRODUCTORY_TEXT,
  TITLE,
  TEXT_CONTENT,
} from './introductory-text-section-data';
import { Container, Title, Text } from './introductory-text-section.styles';

export const IntroductoryTextSection: React.FC = () => (
  <Container>
    {/* @ts-expect-error FIXME: SC6 */}
    <Text
      size="xlarge"
      dangerouslySetInnerHTML={{ __html: INTRODUCTORY_TEXT }}
    />
    <Title size="xxlarge">{TITLE}</Title>
    {/* @ts-expect-error FIXME: SC6 */}
    <Text
      size="xlarge"
      dangerouslySetInnerHTML={{ __html: TEXT_CONTENT }}
      noMargin
    />
  </Container>
);
